// React
import React, { Component } from "react";

// Styles
import './panels.css';

// Components
import { MessageBox, Loader } from '../';

class PanelBody extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {};
            
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('PanelBody.componentDidMount()');

    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('PanelBody.render()');

    // Error has highest priority
    if(this.props.message !== null)
        return (<div className="panel-body"><MessageBox message={this.props.message} /></div>);

    // Then loading
    if(this.props.loading) // <div className="spinner"></div>
        return (<div className="panel-body blank"><Loader /></div>);

    
    return (

        <div className="panel-body">
            {this.props.children}
        </div>

    );
  }
}

export default PanelBody;





// WEBPACK FOOTER //
// ./src/Components/Panels/PanelBody.js